import type { Application } from '../graphql/applications/types'

// The URL section of an application's page -> the resource whose visibility the API computed.
// No permission rule lives here: whether the viewer may open a section is read from
// viewerPermissions / viewerCanManageUsers, which the API fills in per request.
const SECTION_RESOURCE: Record<string, string> = {
  collaborators: 'collaborators',
  'collaborator-functions': 'collaboratorfunctions',
  departments: 'departments',
  locations: 'locations',
  radios: 'radios',
  playlists: 'videoplaylists',
  videos: 'videos',
  podcasts: 'podcasts',
  banners: 'banners',
  events: 'events',
  offerings: 'offerings',
  feed: 'feed',
}

type ViewerApp = Pick<Application, 'viewerPermissions' | 'viewerCanManageUsers'>

// What the API says the viewer may do on a resource of this application (empty when not shown)
export function viewerActions(app: ViewerApp | null | undefined, resource: string): string[] {
  return app?.viewerPermissions?.find(p => p.resource === resource)?.actions ?? []
}

// Whether the viewer sees a resource's section at all
export function viewerSeesResource(app: ViewerApp | null | undefined, resource: string): boolean {
  return !!app?.viewerPermissions?.some(p => p.resource === resource)
}

// Whether the viewer may open the section named in the URL (users: the API's viewerCanManageUsers)
export function viewerOpensSection(app: ViewerApp | null | undefined, section: string): boolean {
  if (section === 'users') {
    return !!app?.viewerCanManageUsers
  }
  const resource = SECTION_RESOURCE[section]
  return !!resource && viewerSeesResource(app, resource)
}
